import Config from '../../common/config/config';
import BookData from './_bookdata';



export default class JsonLoader{


    constructor(){
        this._init();
    }


    /**
     * JSONデータの読み込み
     * @param {function} JSON読み込み完了後のコールバック 
     */
    start(callback){
        this.callback = callback;
        this._load();
    }


    _init(){
        this.JSON_URL = Config.json_file;

        // s1:小学校低学年、s2:小学校中学年、s3:小学校高学年、chu:中学生
        this.books = {
            s1: [], s2: [], s3: [], chu: []
        };
    }


    _load(){
        const xhr = new XMLHttpRequest();
        xhr.open("GET", this.JSON_URL);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onload = () => {
            this._parseJson(JSON.parse(xhr.response));
            if(this.callback) this.callback(this.books);
        };
        xhr.onerror = () => {
            console.log(xhr.status);
        };
        xhr.send();
    }


    _parseJson(datas){

        datas.some((data)=>{
            const grade = data['対象学年'];
            const book = new BookData(data);

            // たいけんひろば版に載せない本を除外する
            const onlyManabi = data['たいけんひろば'];
            if(onlyManabi === '★') {
                //console.log(onlyManabi);
                //console.log(data);
                return;
            }

            if(grade == '小学校低学年') this.books['s1'].push(book);
            else if(grade == '小学校中学年') this.books['s2'].push(book);
            else if(grade == '小学校高学年') this.books['s3'].push(book);
            else if(grade == '中学生') this.books['chu'].push(book);
        });
    }
}
